import { render, staticRenderFns } from "./bom-settle.vue?vue&type=template&id=8e83879e&scoped=true&"
import script from "./bom-settle.vue?vue&type=script&lang=js&"
export * from "./bom-settle.vue?vue&type=script&lang=js&"
import style0 from "./bom-settle.vue?vue&type=style&index=0&id=8e83879e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e83879e",
  null
  
)

export default component.exports